"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
var utils_1 = require("./utils");
var EventNames = {
    INITIALIZED: 'initialized',
    ERROR: 'error'
};
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.events = {};
    }
    EventEmitter.prototype.subscribe = function (key, handler) {
        (0, utils_1.checkParamType)('key', key, 'string');
        (0, utils_1.checkParamType)('handler', handler, 'function');
        var eventNames = Object.keys(EventNames).map(function (e) { return e.toLowerCase(); });
        if (!eventNames.includes(key)) {
            throw new Error('Not a valid event to subscribe to');
        }
        else if (!this.events[key]) {
            this.events[key] = [handler];
        }
        else {
            this.events[key].push(handler);
        }
    };
    EventEmitter.prototype.unsubscribe = function (key, handler) {
        (0, utils_1.checkParamType)('key', key, 'string');
        var eventNames = Object.keys(EventNames).map(function (e) { return e.toLowerCase(); });
        if (!eventNames.includes(key)) {
            return;
        }
        else if (!handler) {
            this.events[key] = [];
        }
        else {
            this.events[key] = this.events[key].filter(function (eventHandler) { return eventHandler !== handler; });
        }
    };
    EventEmitter.prototype.emit = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        (0, utils_1.checkParamType)('key', key, 'string');
        var handlers = this.events[key];
        if (!handlers) {
            this.events[key] = [];
            return;
        }
        handlers.forEach(function (handler) {
            handler.apply(void 0, args);
        });
    };
    EventEmitter.prototype.emitInitialized = function (success) {
        this.emit(EventNames.INITIALIZED, success);
    };
    EventEmitter.prototype.emitError = function (error) {
        this.emit(EventNames.ERROR, error);
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=EventEmitter.js.map